export default __webpack_public_path__ + "static/media/logo512.95ef0c7a.png";